import React from 'react';

import { ProfilFourriereViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { Input } from 'components/WrappedComponents';
import { useApi } from 'hooks/ApiStoreContext';
import { useUserStore } from 'hooks/UserStoreContext';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import {
  FicheProfilFourriereBlocFourriere,
  InputPropFourriere,
} from 'types/FicheProfil/FicheProfilGardienFourriere';
import { CSSUtils } from 'utils/CSSUtils';

import { validateFicheProfilGf } from '../../utils';

function InputPhoneNumber({
  values,
  isEditable,
  generateRequestDto,
}: InputPropFourriere): React.ReactElement {
  const user = useUserStore();
  const gfController = useApi().GardienFourriereControllerApi;
  const key: keyof FicheProfilFourriereBlocFourriere = 'phoneNumber';
  const label = 'Téléphone fixe';

  return (
    <Input
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: label,
          rules: [
            {
              required: true,
              validator: async (
                _rule,
                value: string | undefined,
              ): Promise<void> => {
                return validateFicheProfilGf(
                  gfController,
                  ProfilFourriereViolationDtoFormFieldEnum.TELEPHONE_FIXE,
                  user.idCorrelationFourriere || '',
                  generateRequestDto({ ...values, [key]: value }),
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
        editable: isEditable,
      }}
      inputProps={{
        placeholder: FormPlaceholders.Figures,
      }}
    />
  );
}

export default InputPhoneNumber;
